import { useEffect, useState } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router';
import { adminNavigation, isAdminNavItemActive } from './adminRoutes';
import { LogoutButton } from './components/LogoutButton';
import { ThemeToggleButton } from './components/ThemeToggleButton';
import { AdminNavIcon } from './components/AdminNavIcon';
import { VitegoAppIcon } from '../../components/VitegoAppIcon';
import { useAdminContext } from './AdminContext';

export function AdminLayout() {
  const { authToken, onLogout, onThemeToggle, theme } = useAdminContext();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const workspaceNavigation = adminNavigation.filter((item) => item.route !== 'file-contexts' && item.route !== 'files' && item.route !== 'queues');
  const systemNavigation = adminNavigation.filter((item) => item.route === 'file-contexts' || item.route === 'files' || item.route === 'queues');

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <div className="admin-shell admin-shell_vitego" data-palette="vitego" data-theme={theme}>
      <a className="admin-skip-link" href="#admin-content">Перейти к содержимому</a>
      <aside aria-label="Боковая панель администратора" className="admin-sidebar">
        <div className="admin-sidebar__header">
          <div className="admin-brand">
            <div className="admin-brand__mark"><VitegoAppIcon /></div>
            <div>
              <p className="admin-eyebrow">Vitego</p>
              <strong>Админ-панель</strong>
            </div>
          </div>

          <button
            aria-controls="admin-navigation"
            aria-expanded={isMobileMenuOpen}
            aria-label={isMobileMenuOpen ? 'Закрыть меню' : 'Открыть меню'}
            className="admin-menu-toggle"
            onClick={() => setIsMobileMenuOpen((isOpen) => !isOpen)}
            type="button"
          >
            <span aria-hidden="true" className="admin-menu-toggle__icon" />
          </button>
        </div>

        <nav
          className={`admin-nav${isMobileMenuOpen ? ' is-mobile-open' : ''}`}
          id="admin-navigation"
          aria-label="Основная навигация"
        >
          <AdminNavGroup items={workspaceNavigation} label="Управление" pathname={location.pathname} onNavigate={() => setIsMobileMenuOpen(false)} />
          <AdminNavGroup items={systemNavigation} label="Система" pathname={location.pathname} onNavigate={() => setIsMobileMenuOpen(false)} />
        </nav>

        <div className={`admin-sidebar__bottom${isMobileMenuOpen ? ' is-mobile-open' : ''}`}>
          <div className="admin-sidebar__footer">
            <div className="admin-sidebar__account">
              <span className="admin-sidebar__avatar" aria-hidden="true">
                A
              </span>
              <div className="admin-sidebar__account-text">
                <span>Администратор</span>
                <strong>{authToken.user.user_email}</strong>
              </div>
            </div>
          </div>
          <div className="admin-sidebar__actions">
            <ThemeToggleButton onClick={onThemeToggle} theme={theme} />
            <LogoutButton onClick={onLogout} />
          </div>
        </div>
      </aside>

      <main className="admin-content" id="admin-content">
        <Outlet />
      </main>
    </div>
  );
}

function AdminNavGroup({ items, label, pathname, onNavigate }: { items: typeof adminNavigation; label: string; pathname: string; onNavigate: () => void }) {
  return (
    <div className="admin-nav__group">
      <p className="admin-nav__group-label">{label}</p>
      {items.map((item) => (
        <NavLink
          className={({ isActive }) => (isActive || isAdminNavItemActive(item, pathname) ? 'admin-nav__item is-active' : 'admin-nav__item')}
          end={item.path === '/admin'}
          key={item.route}
          onClick={onNavigate}
          to={item.path}
        >
          <span className="admin-nav__icon"><AdminNavIcon route={item.route} /></span>
          <span className="admin-nav__label">{item.label}</span>
        </NavLink>
      ))}
    </div>
  );
}
